import { create } from "zustand"

const useConversaRascunhoStore = create((set, get) => ({
  // Estado: objeto que mapeia IDs de tickets para rascunhos
  drafts: {},

  // Ação: salvar um rascunho para um ticket específico
  rascunhoSalvar: (ticketId, draftContent) => {
    set((state) => ({
      drafts: {
        ...state.drafts,
        [ticketId]: {
          ...state.drafts[ticketId],
          content: draftContent,
          lastUpdated: new Date().toISOString(),
        },
      },
    }))
  },

  definirMensagemRespondida: (ticketId, mensagemRespondida) => {
    set((state) => ({
      drafts: {
        ...state.drafts,
        [ticketId]: {
          ...state.drafts[ticketId],
          mensagemRespondida: mensagemRespondida,
          lastUpdated: new Date().toISOString(),
        },
      },
    }))
  },

  // Ação: obter um rascunho pelo ID do ticket
  rascunhoCarregar: (ticketId) => {
    return get().drafts[ticketId]?.content || ""
  },

  obterMensagemRespondida: (ticketId) => {
    return get().drafts[ticketId]?.mensagemRespondida || null
  },

  // Ação: atualizar um rascunho existente (CORRIGIDO)
  rascunhoAtualizar: (ticketId, draftContent) => {
    const existingDraft = get().drafts[ticketId]
    const cNovoConteudo = draftContent ?? ""

    if (existingDraft?.content === cNovoConteudo) return

    if (existingDraft) {
      set((state) => ({
        drafts: {
          ...state.drafts,
          [ticketId]: {
            ...state.drafts[ticketId],
            content: cNovoConteudo,
            lastUpdated: new Date().toISOString(),
            createdAt: existingDraft.createdAt || existingDraft.lastUpdated,
          },
        },
      }))
    } else {
      set((state) => ({
        drafts: {
          ...state.drafts,
          [ticketId]: {
            content: cNovoConteudo,
            lastUpdated: new Date().toISOString(),
          },
        },
      }))
    }
  },

  // Ação: remover um rascunho
  rascunhoRemover: (ticketId) => {
    set((state) => {
      const newDrafts = { ...state.drafts }
      delete newDrafts[ticketId]
      return { drafts: newDrafts }
    })
  },

  mensagemRespondidaRemover: (ticketId) => {
    set((state) => ({
      drafts: {
        ...state.drafts,
        [ticketId]: {
          ...state.drafts[ticketId],
          mensagemRespondida: null,
          lastUpdated: new Date().toISOString(),
        },
      },
    }))
  },
  // Ação: limpar todos os rascunhos
  rascunhoRemoverTodos: () => {
    set({ drafts: {} })
  },

  // Ação: obter todos os rascunhos (útil para listagem)
  rascunhoCarregarTodos: () => {
    return get().drafts
  },
}))

export const selectDraftContentByTicket = (ticketId) => (state) => state.drafts[ticketId]?.content || ""
export const selectMensagemRespondidaByTicket = (ticketId) => (state) => state.drafts[ticketId]?.mensagemRespondida || null
export const selectRascunhoActions = (state) => ({
  rascunhoAtualizar: state.rascunhoAtualizar,
  rascunhoRemover: state.rascunhoRemover,
  definirMensagemRespondida: state.definirMensagemRespondida,
  mensagemRespondidaRemover: state.mensagemRespondidaRemover,
})

export default useConversaRascunhoStore
